<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="request-providers__main-container">
                <div class="request-providers__header-container">
                    <span class="request-providers__header-title">
                        Fornecedores da cotação #{{ requestSelected.numeroCotacao }}
                    </span>
                    <span @click="closeDialog" class="material-icons request-providers__closebtn-icon">
                        cancel
                    </span>
                </div>
                <div class="request-provider-body-container">
                    <div class="request-providers__providers-info__container">
                        <div class="request-providers__summary-card request-providers__total-providers__wrapper mobile-info-size">
                            <span class="request-providers__total-providers__title">Total de Fornecedores - ({{
                                providers.length }})</span>
                        </div>
                        <div class="request-providers__summary-card request-providers__engaged-providers__wrapper mobile-info-size">
                            <span class="request-providers__engaged-providers__title">Fornecedores Engajados - ({{
                                get_providers_participant() }})</span>
                        </div>
                        <div class="request-providers__summary-card request-providers__total-entries mobile-info-size">
                            Quantidade de registros: {{ filteredProviders.length }}
                        </div>
                        <div v-if="VIEW == 'LIST'" class="request-providers__switches">
                            <SwitchComponent
                                v-model="showPreviouslyOfferedOnly"
                                label="Oferta anterior"
                            />
                            <SwitchComponent
                                v-model="showCurrentlyOfferedOnly"
                                label="Oferta atual"
                            />
                        </div>
                        <div class="multi-select-container" v-if="VIEW == 'LIST'">
                            <div class="select-header" @click="toggleDropdown">
                                <span class="select-header-text">{{ statusPlaceholder }}</span>
                                <span class="material-icons arrow-icon">
                                    {{ dropdownOpen ? "arrow_drop_up" : "arrow_drop_down" }}
                                </span>
                            </div>
                            <div v-if="dropdownOpen" class="dropdown-options">
                                <div v-for="option in arraySelectStatus" :key="option.value" class="option-item">
                                    <input type="checkbox" :id="'option-' + option.value" :value="option.value"
                                        v-model="selectedStatus" @change="updateFilters" class="option-checkbox" />
                                    <label :for="'option-' + option.value" class="option-label">
                                        {{ option.text }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <StandardButton v-if="VIEW == 'LIST'" class="requets-provider-print-button mobile-input-size" :action="printScrean"
                            iconName="print" text="Imprimir" />

                        <StandardButton v-if="VIEW == 'LIST'" class="requets-provider-print-button mobile-input-size" :action="exportToExcel"
                            iconName="description" text="Exportar Excel" />

                        <StandardButton v-if="VIEW != 'LIST'" class="request-providers-back-button mobile-input-size" :action="goBack"
                            iconName="arrow_back" text="Voltar" />
                    </div>

                    <cc-loader style="margin-top: 20vh; max-height: none !important" v-if="loading" />

                    <div v-else-if="VIEW == 'LIST'" id="printMe" class="request-provider-table-size">
                        <div style="display: flex; align-items: center">
                            <img :src="whitelabel
                                    ? whitelabel.data.imgs.img_logo
                                    : require('@/assets/logo.png')
                                " class="only-print request-print-logo" />
                            <span class="only-print request-print-title">
                                Fornecedores da cotação #{{ requestSelected.numeroCotacao }}
                            </span>
                        </div>
                        <div class="request-providers__table-container">
                            <!-- desktop -->
                            <table class="request-providers__table-wrapper desktop">
                                <thead class="request-providers__table-thead">
                                    <tr class="request-providers__table-thead-tr">
                                        <th
                                            class="request-providers__table-th request-providers__table-th-provider request-provider-width">
                                            <sortable-label
                                                content="Fornecedor"
                                                :direction="providerSortDirection"
                                                @click.native="toggleProviderSort"
                                                :showicon="sortField == 'provider'"
                                            />
                                        </th>
                                        <th class="request-providers__table-th request-seller-width">
                                            Vendedor
                                        </th>
                                        <th class="request-providers__table-th request-email-width">
                                            Email
                                        </th>
                                        <th class="request-providers__table-th request-phone-width">
                                            Telefone
                                        </th>
                                        <th
                                            class="request-providers__table-th request-providers__table-th-cond request-payment-width">
                                            Cond. Pgto.
                                        </th>
                                        <th
                                            class="request-providers__table-th request-providers__table-th-date request-date-width">
                                            Data Entrega
                                        </th>
                                        <th class="request-providers__table-th request-min-width">
                                            Fat. Min.
                                        </th>
                                        <th class="request-providers__table-th request-participation-width"
                                            style="width: 5%">
                                            Cotações
                                        </th>
                                        <th class="request-providers__table-th request-participation-width">
                                            <sortable-label
                                                content="Participação"
                                                :direction="participationSortDirection"
                                                @click.native="toggleParticipationSort"
                                                :showicon="sortField == 'participation'"
                                            />
                                        </th>
                                        <th class="request-providers__table-th request-obs-width">
                                            Observação
                                        </th>
                                        <th class="request-providers__table-th request-status-width">
                                            Status
                                        </th>
                                        <th class="request-providers__table-th actions-width">
                                            Ações
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="request-providers__table-tbody">
                                    <tr v-for="(item, index) in filteredProviders" :key="item.id_vendedor != null ? item.id_vendedor : index"
                                        class="request-providers__table-tbody-tr" :class="getSpecialBackground(index)">
                                        <td class="request-providers__table-td request-providers__table-td--tooltip request-providers__table-th-provider">
                                            <div class="request-providers__copyable-cell">
                                                <CopyComponent
                                                    :text="item.fornecedor_nome || ''"
                                                    title="Copiar fornecedor"
                                                    @copied="handleCopy('Fornecedor copiado')"
                                                />
                                                <TooltipComponent :content="item.fornecedor_nome || '-'">
                                                    <span class="request-providers__cell-text">
                                                        {{ item.fornecedor_nome || "-" }}
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </td>
                                        <td class="request-providers__table-td request-providers__table-td--tooltip">
                                            <div class="request-providers__copyable-cell">
                                                <CopyComponent
                                                    :text="item.vendedor_nome || ''"
                                                    title="Copiar vendedor"
                                                    @copied="handleCopy('Vendedor copiado')"
                                                />
                                                <TooltipComponent :content="item.vendedor_nome || '-'">
                                                    <span class="request-providers__cell-text">
                                                        {{ item.vendedor_nome || "-" }}
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </td>
                                        <td class="request-providers__table-td request-providers__table-td--tooltip">
                                            <div class="request-providers__copyable-cell">
                                                <CopyComponent
                                                    :text="item.vendedor_email || ''"
                                                    title="Copiar email"
                                                    @copied="handleCopy('Email copiado')"
                                                />
                                                <TooltipComponent :content="item.vendedor_email || '-'">
                                                    <span class="request-providers__cell-text">
                                                        {{ item.vendedor_email || "-" }}
                                                    </span>
                                                </TooltipComponent>
                                            </div>
                                        </td>
                                        <td class="request-providers__table-td">
                                            <cc-whatsapp :phone="item.vendedor_telefone" />
                                        </td>
                                        <td class="request-providers__table-td">
                                            <span class="request-providers__cell-text">
                                                {{ item.entrega ? item.entrega.forma : "-" }}
                                            </span>
                                        </td>
                                        <td class="request-providers__table-td request-providers__table-th-date">
                                            <span class="request-providers__cell-text">
                                                {{
                                                item.entrega && item.entrega.data_entrega
                                                    ? formatDate(item.entrega.data_entrega)
                                                    : "-"
                                                }}
                                            </span>
                                        </td>
                                        <td class="request-providers__table-td">
                                            <span class="request-providers__cell-text">
                                                {{
                                                item.entrega && item.entrega.faturamento_minimo
                                                    ? item.entrega.faturamento_minimo.toLocaleString("pt-BR", {
                                                        currency: "BRL",
                                                        style: "currency",
                                                        minimumFractionDigits: 2,
                                            })
                                                    : "-"
                                                }}
                                            </span>
                                        </td>
                                        <td class="request-providers__table-td">
                                            <span class="request-providers__cell-text request-providers__cell-text--center">
                                                {{ item.cotacao_count }}
                                            </span>
                                        </td>
                                        <td class="request-providers__table-td">
                                            <div v-if="item.participation" :class="getPercent(item.participation)">
                                                {{ (item.participation * 100).toFixed(2) + " %" }}
                                            </div>
                                            <span v-else class="request-providers__cell-text request-providers__cell-text--center">-</span>
                                        </td>
                                        <td class="request-providers__table-td request-obs-width request-providers__table-td--center">
                                            <span
                                                v-if="item.entrega && item.entrega.observacao"
                                                style="color: var(--primary-color)"
                                                :title="item.entrega.observacao"
                                                class="material-icons-outlined request-providers__obs-icon"
                                            >
                                                info
                                            </span>
                                            <span v-else class="request-providers__cell-text request-providers__cell-text--center">-</span>
                                        </td>
                                        <td class="request-providers__table-td">
                                            <div class="provider-status-cell">
                                                <div class="provider-status-icon" :class="getStatusIconClass(item.status)">
                                                    <span class="material-icons-outlined">
                                                        {{ getStatusIcon(item.status) }}
                                                    </span>
                                                </div>
                                                <span class="provider-status-label" :class="getStatusIconClass(item.status)">
                                                    {{ formatStatus(item.status) }}
                                                </span>
                                            </div>
                                        </td>
                                        <td class="request-providers__table-td actions-width request-providers__table-td--center">
                                            <!-- <span v-if="showCopy" title="Copiar URL da cotação" @click="
                                                () =>
                                                    copy(
                                                        `https://novo.fornecedor.clubdacotacao.com.br/cotacoes/${requestSelected.numeroCotacao}/vendedor/${item.id_vendedor}?token=${item.auth_token}`
                                                    )
                                            " class="material-icons request-copy-icon no-print">
                                                file_copyv
                                            </span> -->
                                            <div class="provider-actions">
                                                <span
                                                    v-if="item.prev_offered_products_count !== undefined"
                                                    class="info-circle info-circle-prev clickable"
                                                    :title="`Produtos ofertados anteriormente: ${item.prev_offered_products_count}`"
                                                    @click="open_seller_offers(item)"
                                                >
                                                    {{ item.prev_offered_products_count }}
                                                </span>
                                                <span
                                                    v-if="item.offered_products_count !== undefined"
                                                    class="info-circle info-circle-current"
                                                    :title="`Produtos ofertados nesta cotação: ${item.offered_products_count}`"
                                                >
                                                    {{ item.offered_products_count }}
                                                </span>
                                                <span
                                                    class="material-icons-outlined viewed-check-icon"
                                                    :class="{
                                                        'viewed-check-active': item.viewed_at,
                                                        'viewed-check-inactive': !item.viewed_at,
                                                    }"
                                                    :title="
                                                        item.viewed_at
                                                            ? `Visualizado em: ${formatDateTime(item.viewed_at)}`
                                                            : 'Não visualizado'
                                                    "
                                                >
                                                    done_all
                                                </span>
                                                <span v-if="showCopy" title="Enviar Whatsapp com Link" @click="openWhatsapp(item)"
                                                    class="material-icons whatsapp-icon no-print request-providers__action-icon">
                                                    <i class="fab fa-whatsapp"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- mobile -->
                            <div class="mobile" v-for="(item, index) in filteredProviders"
                                :key="item.id_vendedor != null ? item.id_vendedor : index" :class="getSpecialBackground(index)">
                                <p class="mobile-name-table">{{ item.fornecedor_nome || "-" }}</p>
                                <div class="mobile-table-row">
                                    <div style="width: 30vw" class="table-not-typed" v-if="item.status == 'NOT_TYPED'">
                                        Não digitada
                                    </div>
                                    <div style="width: 30vw" class="table-typed" v-else-if="item.status == 'TYPED'">
                                        Digitada
                                    </div>
                                    <div style="width: 30vw" class="table-freezed" v-else-if="item.status == 'FROZEN'">
                                        CONGELADA
                                    </div>
                                    <div style="width: 30vw" class="table-created" v-else-if="item.status == 'ORDERED'">
                                        Pedido Gerado
                                    </div>
                                    <div style="width: 30vw" class="table-nooffer"
                                        v-else-if="item.status == 'NOT_OFFERED'">
                                        SEM OFERTA
                                    </div>
                                    <div class="table-noporder" style="width: 30vw" v-if="item.status == 'NOT_ORDERED'">
                                        SEM PEDIDO
                                    </div>
                                    <div v-else>--</div>
                                    <div style="display: flex; gap: 1vw">
                                        <p class="mobile-table-title">Participação:</p>
                                        <div style="width: 20vw" v-if="item.participation"
                                            :class="getPercent(item.participation)">
                                            {{ (item.participation * 100).toFixed(2) + " %" }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mobile-table-row">
                                    <div style="width: 30%">
                                        <p class="mobile-table-title">Vendedor</p>
                                        {{ item.vendedor_nome || "-" }}
                                    </div>
                                    <div class="mobile-table-center">
                                        <p class="mobile-table-title">Cond. Pgto.</p>
                                        {{ item.entrega ? item.entrega.forma : "-" }}
                                    </div>
                                    <div class="mobile-table-center">
                                        <p class="mobile-table-title">Data Entrega</p>
                                        {{
                                            item.entrega && item.entrega.data_entrega
                                                ? formatDate(item.entrega.data_entrega)
                                        : "-"
                                        }}
                                    </div>
                                    <div class="mobile-table-end">
                                        <p class="mobile-table-title">Fat. Min.</p>
                                        {{
                                            item.entrega && item.entrega.faturamento_minimo
                                                ? item.entrega.faturamento_minimo.toLocaleString("pt-BR", {
                                                    currency: "BRL",
                                                    style: "currency",
                                                    minimumFractionDigits: 2,
                                        })
                                        : "-"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SellerOffers
                        v-else-if="VIEW == 'OFFERS'"
                        :is-sellers-management="true"
                        :request_id="current_request.id"
                        :show_offered_products="true"
                        :seller_id="request_seller.id_vendedor"
                        :for_id="request_seller.id_fornecedor"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QuotationService from "@/services/QuotationService";
import { mapState } from "vuex";
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import XLSX from "sheetjs-style";
import SellerOffers from "@/modals/providers/sellers/_offers.partial";
import SortableLabel from "@/components/ui/labels/sortable-label.component.vue";
import SwitchComponent from "@/components/ui/switch.component.vue";
import TooltipComponent from "@/components/ui/tooltip.component.vue";
import CopyComponent from "@/components/ui/copy.component.vue";

export default {
    props: ["requestSelected", "closeDialog"],
    components: {
        StandardButton,
        SellerOffers,
        SortableLabel,
        SwitchComponent,
        TooltipComponent,
        CopyComponent,
    },
    mixins: [loaderMixin],
    computed: {
        ...mapState(["statuses", "whitelabel"]),
        statusPlaceholder() {
            if (this.selectedStatus.length === 0) return "Selecione o status";
            if (this.selectedStatus.length === this.arraySelectStatus.length)
                return "Todos selecionados";
            if (this.selectedStatus.length > 3)
                return `${this.selectedStatus.length} status selecionados`;

            const selectedNames = this.arraySelectStatus
                .filter((opt) => this.selectedStatus.includes(opt.value))
                .map((opt) => opt.text)
                .join(", ");

            return selectedNames;
        },
        participationSortDirection() {
            return this.participationSortAscending ? 1 : 0;
        },
        providerSortDirection() {
            return this.providerSortAscending ? 1 : 0;
        },
        filteredProviders() {
            let filteredProviders = [...this.providers];

            if (this.selectedStatus && this.selectedStatus.length > 0) {
                const statusMap = {
                    NOT_TYPED: 7,
                    TYPED: 12,
                    FROZEN: 10,
                    ORDERED: 5,
                    NOT_OFFERED: 1,
                    NOT_ORDERED: 11,
                };

                filteredProviders = filteredProviders.filter((item) => {
                    const statusCode = statusMap[item.status];
                    return this.selectedStatus.includes(statusCode);
                });
            }

            if (this.showPreviouslyOfferedOnly) {
                filteredProviders = filteredProviders.filter(
                    (item) => Number(item.prev_offered_products_count) > 0
                );
            }

            if (this.showCurrentlyOfferedOnly) {
                filteredProviders = filteredProviders.filter(
                    (item) => Number(item.offered_products_count) > 0
                );
            }

            return filteredProviders.sort((firstProvider, secondProvider) => {
                if (this.sortField === 'provider') {
                    const firstProviderName = (firstProvider.fornecedor_nome || '').toLowerCase();
                    const secondProviderName = (secondProvider.fornecedor_nome || '').toLowerCase();

                    if (this.providerSortAscending) {
                        return firstProviderName.localeCompare(secondProviderName);
                    }

                    return secondProviderName.localeCompare(firstProviderName);
                }

                const firstParticipation = Number(firstProvider.participation || 0);
                const secondParticipation = Number(secondProvider.participation || 0);

                if (this.participationSortAscending) {
                    return firstParticipation - secondParticipation;
                }

                return secondParticipation - firstParticipation;
            });
        },
    },
    data() {
        return {
            loading: false,
            service: new QuotationService(),
            providers: [],
            arraySelectStatus: [],
            selectedStatus: [],
            showCopy: true,
            dropdownOpen: false,
            VIEW: "LIST",
            participationSortAscending: true,
            showPreviouslyOfferedOnly: false,
            showCurrentlyOfferedOnly: false,
            providerSortAscending: true,
            sortField: "provider",
        };
    },
    methods: {
        exportToExcel() {
            this.is_loading = true;

            try {
                const excelData = {
                    title: `Club da Cotação - Fornecedores da Cotação #${this.requestSelected.numeroCotacao}`,
                    subtitle: `Data de Exportação: ${new Date().toLocaleDateString("pt-BR")}`,
                    header: [
                        "ID",
                        "Fornecedor",
                        "CNPJ",
                        "Estado",
                        "Cidade",
                        "Telefone",
                        "Vendedor",
                        "Tel. Vendedor",
                        "Email",
                        "Status",
                        "Cond. Pagto",
                        "Prazo Entrega",
                        "Valor Mínimo",
                    ],
                    body: this.filteredProviders.map((item) => [
                        String(item.id_fornecedor || "--"),
                        item.fornecedor_nome || "--",
                        item.cnpj || "--",
                        item.estado || "--",
                        item.cidade || "--",
                        item.vendedor_telefone ? this.formatPhone(item.vendedor_telefone) : "--",
                        item.vendedor_nome || "--",
                        item.vendedor_telefone ? this.formatPhone(item.vendedor_telefone) : "--",
                        item.vendedor_email || "--",
                        this.formatStatus(item.status),
                        item.entrega?.forma || "--",
                        item.entrega?.data_entrega
                            ? this.formatDate(item.entrega.data_entrega)
                            : "--",
                        item.entrega?.faturamento_minimo
                            ? this.formatCurrencyValue(item.entrega.faturamento_minimo)
                            : "--",
                    ]),
                };

                const wb = XLSX.utils.book_new();

                const ws_data = [
                    [excelData.title],
                    [excelData.subtitle],
                    [],
                    excelData.header,
                    ...excelData.body,
                ];

                const ws = XLSX.utils.aoa_to_sheet(ws_data);

                ws["!cols"] = [
                    { wch: 8 },
                    { wch: 25 },
                    { wch: 20 },
                    { wch: 10 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 20 },
                    { wch: 15 },
                    { wch: 40 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                ];

                ws["!merges"] = [
                    { s: { r: 0, c: 0 }, e: { r: 0, c: excelData.header.length - 1 } },
                    { s: { r: 1, c: 0 }, e: { r: 1, c: excelData.header.length - 1 } },
                ];

                if (!ws["A1"]) ws["A1"] = { t: "s", v: excelData.title };
                ws["A1"].s = {
                    font: { sz: 16, bold: true, color: { rgb: "000000" } },
                    alignment: { horizontal: "left", vertical: "center" },
                };

                if (!ws["A2"]) ws["A2"] = { t: "s", v: excelData.subtitle };
                ws["A2"].s = {
                    font: { sz: 12, italic: true, color: { rgb: "555555" } },
                    alignment: { horizontal: "left", vertical: "center" },
                };

                for (let c = 0; c < excelData.header.length; c++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: 3, c });
                    if (!ws[cellAddress]) ws[cellAddress] = { t: "s", v: excelData.header[c] };

                    ws[cellAddress].s = {
                        font: {
                            bold: true,
                            color: { rgb: "FFFFFF" },
                            sz: 12,
                        },
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: "FF8C00" },
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center",
                            wrapText: true,
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };
                }

                for (let r = 4; r < excelData.body.length + 4; r++) {
                    for (let c = 0; c < excelData.header.length; c++) {
                        const cellAddress = XLSX.utils.encode_cell({ r, c });
                        if (!ws[cellAddress]) continue;

                        if (!ws[cellAddress].s) ws[cellAddress].s = {};

                        if (c === 12 && excelData.body[r - 4][c] !== "--") {
                            ws[cellAddress].t = "n";
                            ws[cellAddress].z = '"R$"#,##0.00';
                        }

                        ws[cellAddress].s.alignment = {
                            horizontal: "center",
                            vertical: "center",
                            wrapText: true,
                        };
                        ws[cellAddress].s.border = {
                            top: { style: "thin", color: { rgb: "DDDDDD" } },
                            bottom: { style: "thin", color: { rgb: "DDDDDD" } },
                            left: { style: "thin", color: { rgb: "DDDDDD" } },
                            right: { style: "thin", color: { rgb: "DDDDDD" } },
                        };
                    }
                }

                XLSX.utils.book_append_sheet(wb, ws, "Fornecedores");

                const fileName = `Fornecedores_Cotacao_${this.requestSelected.numeroCotacao}.xlsx`;
                XLSX.writeFile(wb, fileName, { bookType: "xlsx", bookSST: true, type: "binary" });

                this.is_loading = false;
            } catch (error) {
                console.error("Erro ao exportar para Excel:", error);
                this.is_loading = false;
            }
        },

        formatPhone(phone) {
            if (!phone) return "--";
            const nums = phone.replace(/\D/g, "");
            return nums.length === 11
                ? nums.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
                : nums.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        },

        formatStatus(status) {
            const statusMap = {
                NOT_TYPED: "Não Digitada",
                TYPED: "Digitada",
                FROZEN: "Congelada",
                ORDERED: "Pedido Gerado",
                NOT_OFFERED: "Sem Oferta",
                NOT_ORDERED: "Sem Pedido",
            };
            return statusMap[status] || "--";
        },
        getStatusIcon(status) {
            const statusIcons = {
                NOT_TYPED: "edit_off",
                TYPED: "edit_note",
                FROZEN: "ac_unit",
                ORDERED: "shopping_bag",
                NOT_OFFERED: "block",
                NOT_ORDERED: "remove_shopping_cart",
            };

            return statusIcons[status] || "help_outline";
        },
        getStatusIconClass(status) {
            const statusClasses = {
                NOT_TYPED: "provider-status-icon--not-typed",
                TYPED: "provider-status-icon--typed",
                FROZEN: "provider-status-icon--freezed",
                ORDERED: "provider-status-icon--ordered",
                NOT_OFFERED: "provider-status-icon--not-offered",
                NOT_ORDERED: "provider-status-icon--not-ordered",
            };

            return statusClasses[status] || "provider-status-icon--default";
        },

        formatDate(date) {
            return date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0];
        },

        formatCurrencyValue(value) {
            return typeof value === "number" ? value : 0;
        },
        handleCopy(message) {
            this.snack(message);
        },
        printScrean() {
            var tableContent = document.querySelector(".request-providers__table-wrapper")
                .outerHTML;
            var logo = document.querySelector(".request-print-logo").outerHTML;
            var title = document.querySelector(".request-print-title").outerHTML;

            var conteudoImpressao =
                "<html>" +
                "<head>" +
                '<meta charset="UTF-8">' +
                '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css">' +
                '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic">' +
                "<title>Fornecedores da Cotação</title>" +
                "<style>" +
                "  @page { size: A4 landscape; margin: 0.5cm; }" +
                "  body { font-family: 'Source Sans Pro', sans-serif; font-size: 10pt; padding: 10px; }" +
                "  .header-print { display: flex; align-items: center; margin-bottom: 15px; }" +
                "  .request-print-logo { width: 100px; height: auto; }" +
                "  .request-print-title { font-size: 16pt; margin-left: 20px; font-weight: bold; }" +
                "  table { width: 100%; border-collapse: collapse; }" +
                "  th { background-color: #f5f5f5; padding: 8px 5px; text-align: left; " +
                "       font-weight: bold; border: 1px solid #ddd; }" +
                "  td { padding: 6px 5px; border: 1px solid #ddd; vertical-align: top; }" +
                "  .table-not-typed, .table-typed, .table-freezed, " +
                "  .table-created, .table-nooffer, .percent-orange { " +
                "    padding: 2px 5px; border-radius: 3px; font-size: 9pt; " +
                "    text-align: center; }" +
                "  .table-not-typed { background-color: lightcoral; color: white; }" +
                "  .table-typed { background-color: lightgreen; color: white; }" +
                "  .table-freezed { background-color: gray; color: white; }" +
                "  .table-created { background-color: lightblue; color: white; }" +
                "  .table-nooffer { outline: 1px solid gray; }" +
                "  .percent-orange { background-color: lightsalmon; color: white; }" +
                "  tr.page-table-line-special { background: #f7f7f7 !important; }" +
                "  .no-print {display: none !important;}" +
                "</style>" +
                "</head>" +
                "<body>" +
                "<div class='header-print'>" +
                logo +
                title +
                "</div>" +
                tableContent +
                "</body></html>";

            var telaImpressao = window.open("", "_blank", "width=1000,height=600");
            telaImpressao.document.write(conteudoImpressao);
            setTimeout(() => {
                telaImpressao.document.close();
                telaImpressao.focus();
                telaImpressao.print();
                telaImpressao.close();
            }, 500);
        },
        copy(value) {
            this.snack("Link Copiado");
            navigator.clipboard.writeText(value);
        },
        getPercent(value) {
            if (value <= 0.3) return "table-not-typed";
            else if (value >= 0.7) return "table-typed";
            else return "percent-orange";
        },
        setStatusValue(value) {
            this.selectedStatus = Array.isArray(value) ? value : [value];
        },
        formatDate(date) {
            return date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0];
        },
        close() {
            this.$emit("close");
        },
        load_providers() {
            this.loading = true;
            return this.service
                .get_request_providers(this.requestSelected.numeroCotacao)
                .then((request) => {
                    this.loading = false;
                    return request.data;
                });
        },
        get_providers_participant() {
            let status = [
                "NÃO DIGITADA",
                "NÃO DIGITADO",
                "AGUARDANDO CONFIRMACAO",
                "NOT_TYPED",
            ];
            return this.providers.filter((p) => !status.includes(p.status)).length;
        },
        getSpecialBackground(index) {
            if (index % 2 != 0) return "page-table-line-special";
        },
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        updateFilters() {
            this.$forceUpdate();
        },
        toggleParticipationSort() {
            this.participationSortAscending = !this.participationSortAscending;
            this.sortField = "participation";
        },
        toggleProviderSort() {
            this.providerSortAscending = !this.providerSortAscending;
            this.sortField = "provider";

        },
        openWhatsapp(item) {
            const numero = item.vendedor_telefone
            const texto = `Segue o link para responder à cotação: https://novo.fornecedor.clubdacotacao.com.br/requests/${item.request_seller_id}?token=${item.auth_token}`

            const url = `https://api.whatsapp.com/send?phone=55${numero}&text=${encodeURIComponent(texto)}`
            window.open(url, '_blank')
        },
        open_seller_offers(seller) {
            this.request_seller = seller;
            this.current_request = { id: this.requestSelected.numeroCotacao };
            this.VIEW = "OFFERS";
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const date = new Date(dateTime);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `${day}/${month}/${year} às ${hours}:${minutes}`;
        },
        goBack(){
            this.VIEW = 'LIST';
        }
    },
    created() {
        let date = new Date(this.requestSelected.dataExpiracao);
        let dateNow = new Date();
        let isExpired = dateNow > date;

        if (isExpired) this.showCopy = false;
        else if (
            this.requestSelected.status_nome == "PEDIDO GERADO" ||
            this.requestSelected.status_nome == "CONGELADA"
        )
            this.showCopy = false;
        this.load_providers().then((data) => (this.providers = data.concorrentes));
        this.statuses.forEach((el) => {
            if (el.name !== "Excluido") {
                this.arraySelectStatus.push({
                    text: el.name,
                    value: el.value,
                });
            }
        });
        this.arraySelectStatus = [
            { text: "Não digitada", value: 7 },
            { text: "Digitada", value: 12 },
            { text: "Congelada", value: 10 },
            { text: "Pedido Gerado", value: 5 },
            { text: "Sem Oferta", value: 1 },
            { text: "Sem Pedido", value: 11 },
        ];
        this.selectedStatus = this.selectedStatus || [];
    },
};
</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    -webkit-overflow-scrolling: touch;
}

.modal-content-container {
    background-color: white;
    min-width: 50vw;
    border-radius: 12px;
}

.request-providers__main-container {
    width: 85vw;
    height: 80vh;
}

.request-providers__header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--primary-color);
}

.request-providers__header-title {
    color: #ffffff;
    letter-spacing: -2%;
    font-weight: 500;
    font-size: 1.5em;
}

.request-providers__closebtn-icon {
    color: #ffffff;
    font-size: 30px;
    cursor: pointer;
}

.request-providers__providers-info__container {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin: 1vh 1vw;
}

.request-providers__summary-card {
    min-height: 30px;
    display: flex;
    align-items: center;
}

.request-providers__total-providers__wrapper {
    background-color: var(--primary-color-opacity);
    padding: 1.4vh 0.9vw;
    border-radius: 8px;
}

.requets-provider-print-button {
    height: 6vh;
}

.request-providers__total-providers__title {
    color: var(--primary-color);
    font-weight: 300;
    font-size: 1rem;
}

.request-providers__engaged-providers__wrapper {
    background-color: #2acd721a;
    padding: 1.4vh 0.5vw;
    border-radius: 8px;
}

.request-providers__total-entries {
    background-color: rgb(204, 227, 235);
    color: rgb(79, 79, 247);
    font-size: 1rem;
    font-weight: 300;
    padding: 1.4vh 0.5vw;
    border-radius: 8px;
}

.request-providers__switches {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
}

.request-providers__engaged-providers__title {
    color: #30aa4c;
    font-weight: 300;
    font-size: 1rem;
}

.request-provider-table-size {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.request-providers__table-container {
    margin: 10px;
    height: 100%;
    border: 1px solid #f5f5f5;
    border-radius: 12px;
    background: #ffffff;
    padding-bottom: 1px;
    overflow: auto;
}

.table-not-typed {
    background-color: lightcoral;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}

.percent-orange {
    background-color: lightsalmon;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}

.table-typed {
    background-color: lightgreen;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}

.table-freezed {
    background-color: gray;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}

.table-created {
    background-color: lightblue;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}

.table-nooffer {
    outline: 1px solid gray;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}

.table-noorder {
    background-color: rgb(178, 230, 206);
    outline: 1px solid rgb(178, 230, 206);
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}

.request-providers__table-wrapper {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    background: #ffffff;
}

.request-providers__table-thead {}

.request-providers__table-thead-tr {
    background-color: #fffefc;
    border: 0.5px solid #e5e5e5;
    color: #605f5f;
    font-size: 1rem;
    font-weight: 400;
}

.request-providers__table-th {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 12px 10px;
    text-align: left;
    white-space: nowrap;
    position: sticky;
    top: 0;
    background: #fffefc;
    z-index: 1;
}

.request-provider-body-container {
    height: 70vh;
    display: flex;
    flex-direction: column;
}

.request-providers__table-tbody {}

.request-providers__table-tbody-tr {
    position: relative;
    z-index: 0;
}

.request-providers__table-tbody-tr:hover {
    z-index: 3;
}

.request-providers__table-tbody-tr:last-child .request-providers__table-td {
    border-bottom: 0;
}

.request-providers__table-td {
    color: #605f5f;
    font-size: 0.65rem;
    font-weight: 300;
    padding: 0px;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-top: 1px solid #efefef;
}

.request-providers__table-td--tooltip {
    overflow: visible;
}

.request-providers__table-td--center {
    text-align: center;
}

.request-copy-icon {
    cursor: pointer;
    font-size: 1rem;
}

.whatsapp-icon {
    color: #4AC959;
    cursor: pointer;
    font-size: 1rem;
}

.request-providers__table-th-provider {
    width: 18%;
}

.request-providers__table-th-date {
    width: 8%;
}

.request-providers__table-th-cond {
    width: 9%;
}

.page-table-line-special {
    background: #f7f7f7;
}

.mobile {
    display: none;
}

.actions-width {
    width: 10%;
}

.request-seller-width {
    width: 14%;
}

.request-email-width {
    width: 15%;
}

.request-phone-width {
    width: 11%;
}

.request-payment-width {
    width: 8%;
}

.request-date-width {
    width: 7%;
}

.request-min-width {
    width: 8%;
}

.request-participation-width {
    width: 8%;
}

.request-obs-width {
    width: 7%;
}

.request-status-width {
    width: 11%;
}

.request-providers__copyable-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    width: 100%;
}

.request-providers__copyable-cell :deep(.ui-tooltip) {
    min-width: 0;
    flex: 1 1 auto;
    width: auto;
    position: relative;
    z-index: 1;
}

.request-providers__copyable-cell :deep(.ui-tooltip:hover) {
    z-index: 4;
}

.request-providers__cell-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.request-providers__cell-text--center {
    text-align: center;
}

.multi-select-container {
    position: relative;
    width: 180px;
    margin-left: auto;
    font-family: inherit;
}

.select-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s ease;
    height: 6vh;
    &:hover {
        border-color: var(--primary-color);
    }
}

.select-header-text {
    color: #605f5f;
    font-size: 0.8rem;
    font-weight: 400;
}

.arrow-icon {
    color: #605f5f;
    font-size: 20px;
}

.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 10;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
    max-height: 300px;
    overflow-y: auto;
}

.option-item {
    padding: 8px 15px;
    display: flex;
    align-items: center;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f7f7f7;
    }
}

.option-checkbox {
    margin-right: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.option-label {
    color: #605f5f;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    flex-grow: 1;
}

.info-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 0.7rem;
    font-weight: 600;
    color: white;
    flex-shrink: 0;
    cursor: help;
}

.request-providers__obs-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.info-circle-prev {
    background-color: #6c757d;
}

.info-circle.clickable {
    cursor: pointer;
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.info-circle.clickable:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.info-circle-current {
    background-color: var(--primary-color);
}

.viewed-check-icon {
    font-size: 1rem;
    margin-left: 4px;
    cursor: help;
    transition: color 0.2s ease;
}

.viewed-check-active {
    color: #25b8d3;
}

.viewed-check-inactive {
    color: #999999;
}

.provider-status {
    display: flex;
    align-items: center;
    justify-content: center;
}

.provider-status-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    flex-shrink: 0;
}

.provider-status-icon .material-icons-outlined {
    font-size: 1.2rem;
}

.provider-status-icon--not-typed {
    background: rgba(240, 128, 128, 0.16);
    color: lightcoral;
}

.provider-status-icon--typed {
    background: rgba(144, 238, 144, 0.2);
    color: #49b95d;
}

.provider-status-icon--freezed {
    background: rgba(107, 114, 128, 0.16);
    color: #6b7280;
}

.provider-status-icon--ordered {
    background: rgba(173, 216, 230, 0.24);
    color: #4daecc;
}

.provider-status-icon--not-offered {
    background: rgba(156, 163, 175, 0.16);
    color: #6b7280;
}

.provider-status-icon--not-ordered {
    background: rgba(178, 230, 206, 0.3);
    color: #3d9274;
}

.provider-status-icon--default {
    background: rgba(209, 213, 219, 0.2);
    color: #6b7280;
}

.provider-status-cell {
    display: flex;
    align-items: center;
    justify-content: start;
    white-space: nowrap;
}

.provider-status-label {
    font-size: 0.8rem;
    font-weight: 500;
    background: transparent !important;
    width: auto !important;
    height: auto !important;
    border-radius: 0 !important;
}

.provider-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
    width: 100%;
    min-width: 0;
    padding: 0;
}

.request-providers__action-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.request-providers-back-button {
    margin-left: auto;
    height: 6vh;
}

@media only screen and (max-width: 850px) {
    .mobile {
        display: block;
    }

    .request-providers__header-title {
        font-size: 24px;
    }

    .request-providers__total-providers__title {
        font-size: 0.8rem;
    }

    .request-providers__engaged-providers__title {
        font-size: 0.8rem;
    }

    .request-providers__total-entries {
        font-size: 0.8rem;
    }

    .request-providers__table-container {
        height: 60vh;
    }

    .request-providers__providers-info__container {
        justify-content: space-between;
        align-items: flex-end;
    }

    .mobile-info-size {
        width: 31%;
        text-align: center;
        margin: 0;
        height: 12vh;
    }

    .mobile-input-size {
        width: 45%;
    }

    .request-providers__switches {
        width: 100%;
        justify-content: space-between;
        margin-left: 0;
    }

    .request-provider-table-size {
        height: 75%;
    }

    .mobile-table-row {
        display: flex;
        justify-content: space-between;
        padding-bottom: 2vh;
    }

    .mobile-name-table {
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 0;
        padding-top: 2vh;
    }

    .mobile-table-title {
        font-size: 1.1em;
        font-weight: bold;
        margin: 0;
    }

    .mobile-table-end {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 20%;
    }

    .mobile-table-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 30%;
    }

    .desktop {
        display: none;
    }

    .multi-select-container {
        width: 95%;
        margin: 10px auto;
    }

    .select-header {
        padding: 12px 15px;
    }

    .option-item {
        padding: 10px 15px;
    }
}

@media print {
    body>*:not(.request-providers__table-wrapper):not(.request-print-logo):not(.request-print-title) {
        display: none !important;
    }

    .no-print {
        display: none !important;
    }
}

@supports (-webkit-touch-callout: none) {
    .modal-content-container {
        overscroll-behavior: contain;
    }

    .request-providers__table-container {
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
    }

    @media screen and (max-width: 768px) {

        input,
        select,
        textarea {
            font-size: 0.8rem !important;
        }
    }
}

@import "./request-providers.modal";
</style>
